( function () {
	'use strict';

	function obsInitTransform ( $window, $timeout, TOOLTIP_MESSAGES ) {
		function link ( scope, elem ) {
			var header      = angular.element( '.obs-header' );
			var footer      = angular.element( '.obs-footer' );
			var pool        = angular.element( '.obs-pool' );
			var groupPanel  = angular.element( '.obs-group-level' );
			var leftOpenBtn = angular.element( '.obs-pool-small-btn' );
			var poolLockBtn = angular.element( '.pool-lock' );
			var main        = angular.element( elem );
			var w           = angular.element( $window );

			scope.isOpen = false;

			function getElDimensions () {
				return {
					'headerH' : header.height(),
					'footerH' : footer.height(),
					'wH'      : w.height(),
					'poolW'   : pool.width(),
					'groupW'  : groupPanel.width()
				};
			}

			function collapseHeader ( ev ) {
				if ( angular.element( ev.currentTarget ).hasClass( 'icon-angle-double-up' ) ) {
					angular.element( ev.currentTarget ).removeClass( 'icon-angle-double-up' ).addClass( 'icon-angle-double-down' );
					scope.tooltipDetails = TOOLTIP_MESSAGES.obsDownMsg;
				} else {
					angular.element( ev.currentTarget ).removeClass( 'icon-angle-double-down' ).addClass( 'icon-angle-double-up' );
					scope.tooltipDetails = TOOLTIP_MESSAGES.obsUpMsg;
				}

				header.find( '.panel-body' ).slideToggle( function () {
					scope.$apply();
				} );
			}

			function hidePool () {
				pool.find( '.panel' ).hide();
				pool.addClass( 'fixed-left-small' );
				leftOpenBtn.show();
				poolLockBtn.show();
			}

			function collapsePool ( ev ) {
				var el = angular.element( '.quick-access-well' );

				if ( ev ) {
					el = angular.element( ev.currentTarget );
				}

				if ( !scope.locked ) {
					scope.isOpen = !scope.isOpen;

					if ( el.hasClass( 'icon-arrow-circle-right' ) ) {
						scope.tooltipPool = TOOLTIP_MESSAGES.obsShowQAccessMsg;
						pool.find( '.panel' ).hide( 'fade', 'fast', function () {
							pool.addClass( 'fixed-left-small' );
							leftOpenBtn.show( 'fade', 'fast', function () {
								scope.$apply();
							} );
							poolLockBtn.show( 'fade', 'fast' );
						} );
					} else {
						scope.tooltipPool = TOOLTIP_MESSAGES.obsHideQAccessMsg;
						leftOpenBtn.hide( 'fade', 'fast', function () {
							pool.removeClass( 'fixed-left-small' );
							pool.find( '.panel' ).show( 'fade', 'fast', function () {
								scope.$apply();
							} );
							poolLockBtn.hide( 'fade', 'fast' );
						} );
					}
				}
			}

			function calculateHeader ( height ) {
				main.css( {
					'paddingTop' : height - 34 + 'px'
				} );
			}

			function calculateGroupContainer ( gwidth, pwidth ) {
				var allowance = 30;

				if ( pool.length !== 0 ) {
					if ( w.width() < 992 ) {
						allowance = 30;

						if ( leftOpenBtn.is( ':visible' ) ) {
							allowance = 0;
						}
					}
					groupPanel.css( 'cssText', 'padding-right : ' + parseInt( pwidth + allowance ) + 'px !important;' );
				}
			}

			function setPoolHeight ( n ) {
				var poolContent = pool.find( '.edit-scrollable' );
				var allowance   = 200;
				var poolHeight  = ( n.wH - ( n.headerH )  ) - allowance;

				poolContent.css( {
					'height' : poolHeight + 'px'
				} );
			}

			function lockPool () {
				scope.locked = !scope.locked;

				if ( scope.locked ) {
					scope.tooltipLock = TOOLTIP_MESSAGES.obsUnlockMsg;
				} else {
					scope.tooltipLock = TOOLTIP_MESSAGES.obsLockMsg;
				}
			}

			scope.getElDimensions = getElDimensions;
			scope.collapseHeader  = collapseHeader;
			scope.collapsePool    = collapsePool;
			scope.lockPool        = lockPool;

			function init () {
				scope.locked         = false;
				scope.tooltipPool    = TOOLTIP_MESSAGES.obsShowQAccessMsg;
				scope.tooltipLock    = TOOLTIP_MESSAGES.obsLockMsg;
				scope.tooltipDetails = TOOLTIP_MESSAGES.obsUpMsg;

				hidePool();

				header.find( '.panel-body' ).slideToggle( function () {
					scope.$apply();
				} );

				$timeout( function () {
					scope.$watch( scope.getElDimensions, function ( newValue ) {
						if ( main.length ) {
							if ( w.width() < 992 ) {
								newValue.headerH = newValue.headerH + 20;
							}
							calculateHeader( newValue.headerH );
							calculateGroupContainer( newValue.groupW, newValue.poolW );
							setPoolHeight( newValue );
						}
					}, true );
				}, 0 );
			}

			init();

			scope.$on( 'quick:access:collapse', function () {
				if ( !scope.isOpen ) {
					collapsePool();
				}
			} );
		}

		return {
			'restrict' : 'A',
			'link'     : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'obsInitTransform', obsInitTransform );
} )( );
